import React from "react";
import { HomeSection } from "./HomeSection";
import { Box } from "@mui/material";
import { projectDefinitions } from "../projects/projectDefinitions";
import { ProjectItem } from "../projects/ProjectItem";

export function ProjectsSection() {
  return (
    <HomeSection
      id="projects"
      title="Projects"
      description="Standalone apps and projects from beyond this collection."
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fill, minmax(min(100%, 280px), 1fr))",
          gap: "1rem"
        }}
      >
        {projectDefinitions.map((project) => (
          <ProjectItem key={project.name} project={project} />
        ))}
      </Box>
    </HomeSection>
  );
}
